var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilledYellowStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.77635 1.38529C10.0612 0.76777 10.9388 0.767771 11.2237 1.38529L13.6988 6.7514C13.8149 7.00307 14.0534 7.17636 14.3286 7.20899L20.197 7.90478C20.8723 7.98485 21.1435 8.81953 20.6442 9.28125L16.3056 13.2935C16.1021 13.4817 16.011 13.762 16.065 14.0339L17.2167 19.83C17.3492 20.497 16.6392 21.0129 16.0458 20.6807L10.8893 17.7943C10.6474 17.6589 10.3526 17.6589 10.1107 17.7943L4.95419 20.6807C4.36079 21.0129 3.65076 20.497 3.78329 19.83L4.93498 14.0339C4.98899 13.762 4.89789 13.4817 4.69441 13.2935L0.355793 9.28125C-0.143481 8.81953 0.127727 7.98485 0.803037 7.90478L6.67137 7.20899C6.9466 7.17636 7.18511 7.00307 7.3012 6.7514L9.77635 1.38529Z",
    fill: "#FEE502"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledYellowStar);
export default __webpack_public_path__ + "static/media/filledYellowStar.c736704f1423b0e16cf7b7699dd90cdb.svg";
export { ForwardRef as ReactComponent };